var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMicrosoftLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB900",
    d: "M8.397 8.397H16V16H8.397V8.397z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A4EF",
    d: "M0 8.397h7.603V16H0V8.397z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FBA00",
    d: "M8.397 0H16v7.603H8.397V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F25022",
    d: "M0 0h7.603v7.603H0V0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicrosoftLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/microsoft_logo.93d5159d.svg";
export { ForwardRef as ReactComponent };